import { render } from 'preact';
import { watchErrors } from './live/feedback';
import { moveFromAddress } from './lib/move';
import { watchForUpdates } from './lib/updates';
import { App } from './ui/App';
import { MoveIn } from './ui/MoveIn';
import { watchTextScale } from './ui/textsize';
import './ui/styles.css';

// "?silent" in the address mutes every sound (automated checks must never play audio aloud).
if (new URLSearchParams(location.search).has('silent')) (globalThis as unknown as { __ahillahSilent?: boolean }).__ahillahSilent = true;

// Errors Ahillah meets, kept in memory to go with feedback (src/live/feedback.ts).
watchErrors();
// Text follows the reader's own size setting from the first frame.
watchTextScale();
watchForUpdates();
// The sky draws Arabic names on a canvas, which does not fetch a web font by itself: ask for the Arabic face now.
void document.fonts?.load('16px "Adwa as-Salaf"', 'ا').catch(() => undefined);
// And the King Fahd Complex's face, for the verse on the start-up screen (src/ui/StartVerse.tsx).
void document.fonts?.load('16px "KFGQPC Hafs"', 'ٱ').catch(() => undefined);
// Arriving from the old address with everything saved there (?move=…#key=…): that comes across first.
const move = moveFromAddress();
render(move ? <MoveIn id={move.id} moveKey={move.key} /> : <App />, document.getElementById('app')!);
